import React, { useState } from 'react';
import axios from 'axios';
import { generateAvatarUploadUrl } from '../services/api';
import { validateImageFile, generatePreview, resizeAvatar } from '../utils/imageUtils';
import './AvatarUpload.css';

function AvatarUpload({ organizationId, userId, currentAvatarUrl, onAvatarUploaded }) {
  const [previewUrl, setPreviewUrl] = useState(currentAvatarUrl || null);
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState(null);

  const handleFileSelect = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setError(null);
    setUploading(true);

    try {
      // 1. Validar archivo
      const validation = validateImageFile(file, 2);
      if (!validation.valid) {
        setError(validation.error);
        setUploading(false);
        return;
      }

      // 2. Generar preview inmediato
      const preview = await generatePreview(file);
      setPreviewUrl(preview);

      // 3. Redimensionar avatar (300x300px)
      console.log('[AvatarUpload] Redimensionando avatar...');
      const resizedFile = await resizeAvatar(file);

      // 4. Obtener presigned URL del backend
      const { uploadUrl, avatarUrl } = await generateAvatarUploadUrl(
        organizationId,
        userId,
        resizedFile.type
      );

      // 5. Subir archivo redimensionado directamente a S3
      await axios.put(uploadUrl, resizedFile, {
        headers: {
          'Content-Type': resizedFile.type,
        },
      });

      // 6. Notificar al componente padre con la URL de CloudFront
      onAvatarUploaded(avatarUrl);

      console.log('[AvatarUpload] Avatar subido exitosamente:', avatarUrl);
    } catch (err) {
      console.error('Error uploading avatar:', err);
      setError('Error al subir el avatar. Por favor intenta nuevamente.');
      setPreviewUrl(currentAvatarUrl || null);
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="avatar-upload">
      <label className="avatar-upload-label">Avatar</label>

      <div className="avatar-preview-container">
        {previewUrl ? (
          <div className="avatar-preview">
            <img src={previewUrl} alt="Avatar preview" />
            {uploading && (
              <div className="avatar-upload-overlay">
                <div className="spinner"></div>
              </div>
            )}
          </div>
        ) : (
          <div className="avatar-preview avatar-placeholder">
            <span>Sin avatar</span>
          </div>
        )}
      </div>

      <div className="avatar-upload-actions">
        <input
          type="file"
          accept="image/*"
          onChange={handleFileSelect}
          disabled={uploading}
          id="avatar-file-input"
          style={{ display: 'none' }}
        />

        <label
          htmlFor="avatar-file-input"
          className={`btn btn-secondary btn-small ${uploading ? 'disabled' : ''}`}
        >
          {uploading ? 'Subiendo...' : previewUrl ? 'Cambiar' : 'Seleccionar'}
        </label>
      </div>

      {error && <p className="error-message">{error}</p>}

      {uploading && <p className="upload-info">⚡ Optimizando avatar...</p>}
    </div>
  );
}

export default AvatarUpload;
